import { render, staticRenderFns } from "./AddNews.vue?vue&type=template&id=6f33791e&"
import script from "./AddNews.vue?vue&type=script&lang=js&"
export * from "./AddNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports